export interface ITeam {
  id: number;
  orgId: string;
  name: string;
  description: string;
  ownerUserId: string;
  parent?: any;
  type: string;
  members: any[];
  code: string;
  chatEnabled: boolean;
  ownerFullName: string;
  memberCount: number;
}

export interface IGetTeamsResponse {
  data: ITeam[];
}

export enum TeamType {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC"
}

export interface ICreateTeamPayload {
  teamId?: string | undefined;
  code: string;
  name: string;
  description: string;
  parentTeamId?: number | null | undefined;
  defaultChatOwnerUserId: string;
  memberUserIdList: string[];
  type?: TeamType;
}

export interface ICreateTeamResponse {
  data: {
    id: number;
    orgId: string;
    name: string;
    description: string;
    ownerUserId: string;
    parent?: any;
    type: string;
    members: any[];
  };
}
